.page { display: flex; flex-direction: column; gap: 16px; padding-bottom: 32px; min-width: 0; }
.search { background: var(--card); border: 0; border-radius: 16px; box-shadow: var(--sh); padding: 16px; display: flex; flex-direction: column; gap: 14px; }
.search { max-width: 100%; margin: 0; box-sizing: border-box; }
.searchStart { max-width: 880px; width: 100%; margin: 96px auto 0; padding: 28px 32px; }
.recentStart { max-width: 880px; width: 100%; margin: 0 auto; }
@media (prefers-reduced-motion: no-preference) { .search { transition: margin 320ms ease, max-width 320ms ease, padding 320ms ease; } }
.lead h2 { margin: 0; font-size: 20px; font-weight: var(--fw-title); color: var(--tx); }
.lead p { margin: 4px 0 0; color: var(--lb); font-size: 14px; }
.row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px; }
.port { position: relative; display: flex; flex-direction: column; gap: 6px; flex: 1 1 220px; min-width: 0; }
.polSwap { display: flex; align-items: flex-end; flex: 1 1 280px; min-width: 0; gap: 0; }
.polSwap .swap { height: 40px; margin-left: -1px; border-radius: 0 10px 10px 0; background: var(--sub); }
.row2 { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; }
.cargo { position: relative; }
.cargoBtn { height: 40px; padding: 0 12px; border-radius: 10px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; font-weight: var(--fw-label); display: inline-flex; align-items: center; gap: 8px; cursor: pointer; }
.cargoBtn:focus-visible { outline: 2px solid var(--pri); }
.cargo .sug { right: auto; min-width: 280px; }
.select { height: 40px; padding: 0 12px; border-radius: 10px; border: 1px solid var(--bd); background: var(--card); color: var(--tx); font: inherit; }
.select:focus-visible { outline: 2px solid var(--pri); }
.swap { flex: none; }
.ctl { display: flex; flex-direction: column; gap: 6px; }
.ctlLb { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: var(--fw-label); color: var(--lb); }
.sug { position: absolute; z-index: 5; top: 100%; left: 0; right: 0; margin-top: 4px; background: var(--card); border-radius: 12px; box-shadow: var(--pop); padding: 4px; max-height: 280px; overflow: auto; }
.sugBtn { display: grid; grid-template-columns: 64px 1fr auto; gap: 8px; width: 100%; text-align: left; border: 0; background: transparent; color: var(--tx); font: inherit; padding: 8px 10px; border-radius: 8px; cursor: pointer; }
.sugBtn span { color: var(--lb); font-size: 12.5px; }
.sugBtn:focus-visible { outline: 2px solid var(--pri); }
@media (hover: hover) { .sugBtn:hover { background: var(--sub); } }
.recent h3 { margin: 0 0 8px; font-size: 14px; font-weight: var(--fw-title); color: var(--tx); }
.recentGrid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 10px; }
.recentBtn { display: flex; flex-direction: column; gap: 2px; text-align: left; padding: 14px 16px; border-radius: 12px; border: 0; box-shadow: var(--sh); background: var(--card); color: var(--tx); font: inherit; cursor: pointer; }
.recentBtn b { font-size: 16px; font-weight: var(--fw-title); }
.recentBtn span { color: var(--lb); font-size: 12.5px; }
.recentBtn:focus-visible { outline: 2px solid var(--pri); }
@media (hover: hover) { .recentBtn:hover { box-shadow: var(--sh-hi); } }
.bar { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }
.grow { flex: 1; }
.chips { display: flex; flex-wrap: wrap; gap: 6px; }
.chipBtn { height: 30px; padding: 0 12px; border-radius: 999px; border: 1px solid var(--bd); background: var(--card); color: var(--tx2); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; display: inline-flex; align-items: center; gap: 6px; }
.chipBtn span { color: var(--lb); font-weight: 400; }
.chipBtn[aria-pressed='true'] { background: var(--pri-bg); border-color: var(--pri-bd); color: var(--link); }
.chipBtn:focus-visible { outline: 2px solid var(--pri); }
.list { display: flex; flex-direction: column; gap: 10px; }
.card { background: var(--card); border: 1px solid var(--bd); border-radius: 14px; box-shadow: var(--sh); }
.cardMain { display: grid; grid-template-columns: minmax(150px, 1.1fr) minmax(220px, 1.6fr) minmax(180px, 1.2fr) minmax(150px, 1fr) 44px; gap: 16px; align-items: center; padding: 14px 16px; }
.car { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.carTop { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.carCode { font-weight: var(--fw-title); color: var(--tx); font-size: 15px; }
.carName { color: var(--lb); font-size: 12.5px; }
.sub { color: var(--lb); font-size: 12.5px; }
.axis { display: grid; grid-template-columns: auto 1fr auto; gap: 10px; align-items: center; }
.axis b { color: var(--tx); font-weight: var(--fw-title); }
.axis small { display: block; color: var(--lb); font-size: 11.5px; max-width: 90px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.line { display: flex; flex-direction: column; align-items: center; gap: 3px; color: var(--lb); font-size: 12px; }
.line i { display: block; height: 2px; width: 100%; background: var(--route); border-radius: 2px; }
.prices { display: flex; gap: 18px; }
.price { display: flex; flex-direction: column; }
.price small { color: var(--lb); font-size: 11.5px; font-weight: var(--fw-label); }
.price b { font-size: 17px; font-weight: var(--fw-title); color: var(--tx); font-variant-numeric: tabular-nums; }
.price span { white-space: nowrap; color: var(--lb); font-size: 11.5px; font-variant-numeric: tabular-nums; }
.price span.low { color: var(--warn); }
.valid { display: flex; flex-direction: column; gap: 2px; font-size: 13px; color: var(--tx2); }
.detail { border-top: 1px solid var(--line); padding: 14px 16px; display: flex; flex-direction: column; gap: 12px; background: var(--sub); border-radius: 0 0 14px 14px; }
.meta { display: flex; flex-wrap: wrap; gap: 6px; }
.history { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 4px; font-size: 13px; color: var(--tx2); }
.empty { padding: 28px 16px; text-align: center; color: var(--lb); display: flex; flex-direction: column; align-items: center; gap: 8px; }
.skel { display: flex; flex-direction: column; gap: 10px; }
.skelRow { height: 76px; border-radius: 14px; background: var(--skel); }
.note { font-size: 13px; color: var(--lb); }
.sched { margin: 0; width: 100%; min-width: 0; }
@media (max-width: 1100px) {
  .cardMain { grid-template-columns: 1fr 1fr 44px; }
  .axis { grid-column: 1 / -1; order: 3; }
}
@media (max-width: 767px) {
  .page { padding-bottom: 24px; }
  .searchStart { margin-top: 0; padding: 16px; max-width: 100%; }
  .cardMain { grid-template-columns: minmax(0, 1fr) 44px; gap: 10px; }
  .cardMain > * { grid-column: 1; min-width: 0; }
  .cardMain > button { grid-column: 2; grid-row: 1; }
  .axis { order: 0; }
  .row { flex-direction: column; align-items: stretch; }
  .port { flex-basis: auto; }
  .swap { align-self: center; }
  .prices { gap: 24px; }
}
@media (prefers-reduced-motion: no-preference) { .card { transition: box-shadow 0.15s; } }

.pSearch { background: var(--card); border-radius: 14px; box-shadow: var(--sh); padding: 14px; display: flex; flex-direction: column; gap: 12px; }
.pFrom { margin: 0; font-size: 13px; color: var(--lb); }
.pFrom b { color: var(--tx); font-weight: var(--fw-label); }
.pPods { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 6px; }
.pPod { height: 36px; border-radius: 10px; border: 0; background: var(--sub); color: var(--tx2); font: inherit; font-size: 13px; font-weight: var(--fw-label); cursor: pointer; }
.pPod[aria-pressed='true'] { background: var(--pri-bg); color: var(--link); }
.pPod:focus-visible { outline: 2px solid var(--pri); }
.pSearch > button:last-child { width: 100%; }

.vHead { margin: 0; font-size: 15px; font-weight: var(--fw-title); color: var(--tx); }
.vcard { display: flex; flex-direction: column; gap: 10px; padding: 14px; background: var(--card); border: 1px solid var(--bd); border-radius: 16px; box-shadow: var(--sh); }
.vcard > button { width: 100%; }
.vTop { display: grid; grid-template-columns: auto 1fr auto; gap: 10px; align-items: center; }
.vDate { display: flex; flex-direction: column; gap: 2px; }
.vDate small { color: var(--lb); font-size: 11px; }
.vDate b { font-size: 18px; font-weight: var(--fw-title); color: var(--tx); }
.vEnd { align-items: flex-end; }
.vAxis { display: flex; flex-direction: column; align-items: center; gap: 4px; color: var(--lb); font-size: 11.5px; }
.vAxis i { align-self: stretch; height: 2px; border-radius: 1px; background: var(--bd); }
.vCities { display: flex; justify-content: space-between; color: var(--lb); font-size: 11px; }
.vMeta { display: flex; flex-direction: column; gap: 4px; font-size: 13px; color: var(--tx); }
.vMeta > span:first-child { display: flex; align-items: center; gap: 6px; }
.vCut { color: var(--tx2); font-size: 12.5px; }
.vCut b { color: var(--tx); font-weight: var(--fw-label); }
.vCar { align-self: flex-start; padding: 2px 8px; border-radius: 8px; background: var(--sub); color: var(--tx2); font-size: 12px; }
.runSched { margin-left: auto; height: 42px; }
.rowSched { align-items: flex-end; }
.rowSched { padding-inline: 2px; }
.rowSched .polSwap { flex: 0 0 280px; }
.rowSched > .port { flex: 0 0 238px; }

.flt { position: relative; }
.pop { position: absolute; right: 0; top: calc(100% + 8px); z-index: 30; width: 360px; padding: 14px; border-radius: 14px; background: var(--card); box-shadow: var(--pop); display: flex; flex-direction: column; gap: 12px; }
.grp { display: flex; flex-direction: column; gap: 6px; align-items: flex-start; }
.grp > span { font-size: 12px; color: var(--lb); }
.popFoot { display: flex; align-items: center; gap: 8px; padding-top: 10px; border-top: 1px solid var(--line); font-size: 12px; color: var(--lb); }

/* Bước kết quả khổ iPad / điện thoại (board Mint-P2P-iPad · Phone): điều kiện thu một hàng, thanh công cụ, dock điện thoại */
.pdCond { background: var(--card); border-radius: 18px; box-shadow: var(--sh); padding: 16px; display: flex; flex-direction: column; gap: 12px; }
.pdRow { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.pdPol { height: 44px; padding: 0 14px; border-radius: 12px; background: var(--ctl); display: inline-flex; align-items: center; font-size: 15px; font-weight: var(--fw-label); }
.pdArrow { color: var(--lb); }
.pdPod { height: 44px; padding: 0 14px; border: 0; border-radius: 12px; background: var(--ctl); color: var(--tx2); font: inherit; font-size: 15px; cursor: pointer; white-space: nowrap; }
.pdPod b { font-weight: var(--fw-label); color: var(--tx); }
.pdPod[aria-pressed='true'] { background: var(--pri-bg); color: var(--link); }
.pdPod[aria-pressed='true'] b { color: var(--link); }
.pdMeta { flex-grow: 1; font-size: 13px; color: var(--lb); text-align: right; }
.pdDock { position: sticky; bottom: 0; z-index: 5; display: flex; gap: 10px; padding: 10px 0 12px; background: var(--bg); }
.pdDock > button { flex: 1 1 0; height: 48px; }
@media (max-width: 767px) { .pdCond { padding: 0; background: transparent; box-shadow: none; } }
.pdCond > :last-child { align-self: flex-start; }

/* Mint-P2P: hàng tra — ô cảng 230px, nút đổi chiều 40×40 đứng riêng, khoảng cách 10px */
@media (min-width: 768px) {
  .row:not(.rowSched) { gap: 10px; }
  .row:not(.rowSched) .polSwap { display: contents; }
  .row:not(.rowSched) .port { flex: 0 0 230px; gap: 4px; }
  .row:not(.rowSched) .polSwap .swap { width: 40px; margin: 0; border-radius: 10px; background: var(--ctl); }
  .row:not(.rowSched) .ctl { gap: 4px; }
  .searchStart { border-radius: 20px; }
  .searchStart .lead h2 { font-size: 22px; letter-spacing: -0.01em; }
}

/* Desktop đã tra giá (board Mint-P2P · -1920, bước kết quả): thanh điều kiện một hàng + kết quả trong một thẻ. */
.resPlain { display: contents; }
.resCard { background: var(--card); border-radius: 16px; box-shadow: var(--sh); padding: 16px; display: flex; flex-direction: column; gap: 14px; }
.rowOne { flex-wrap: nowrap; gap: 24px; }
.rowOne .polSwap { flex: 0 1 253px; }
.rowOne .port { flex: 0 1 253px; }
.runRes { margin-left: auto; }

/* Mint-P2P-iPad (chưa tra): thẻ 680px giữa trang, loại hàng bên trái + nút Tra giá bên phải */
.pdStart { width: 680px; max-width: 100%; margin: 114px auto 0; align-self: center; }
.pdAct { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.pdCond > .pdAct { align-self: stretch; }
.pdAct button { height: 40px; font-size: 15px; padding-inline: 14px; }
.pdAct > button { height: 44px; padding-inline: 16px; }
